module.exports = __webpack_public_path__ + "fonts/GothamProMediumItalic.woff";